import React, { Component, Fragment } from "react"
import { withStyles } from "@material-ui/core/styles"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import FormHelperText from "@material-ui/core/FormHelperText"
import "react-phone-number-input/style.css"
import PhoneInput from "react-phone-number-input"
import countries from "../../assets/countries.json"
import styles from "./styles"
import update from "immutability-helper"
import { parseNumber } from "libphonenumber-js"
import { isEmpty } from "lodash"
import InfoCircle from "../InfoCircle"

const FlagComponent = props => {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/flags/${props.country}.png`}
      alt={props.country}
    />
  )
}

class PhoneInputComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      phoneInputFocused: false,
      country: "US",
      validity: {},
      touched: false,
    }
  }
  componentDidMount() {
    this.setInitialValidity()
  }
  setInitialValidity = () => {
    let validity = {}
    let inputValidity = document.getElementById(this.props.id || "phoneInput")
      .validity
    for (const key in inputValidity) {
      validity[key] = inputValidity[key]
    }
    validity.phone = false
    validity.valid = false
    this.setState(
      update(this.state, {
        validity: {
          $set: validity,
        },
      })
    )
    if (this.props.hasOwnProperty("setValidity")) {
      this.props.setValidity(validity)
    }
  }
  handleBlur = e => {
    this.setState({
      phoneInputFocused: false,
      touched: true,
    })
  }
  handleFocus = e => {
    this.setState({
      phoneInputFocused: true,
    })
  }
  handleCountryChange = country => {
    this.setState({
      country,
    })
    if (this.props.hasOwnProperty("onCountryChange")) {
      this.props.onCountryChange(country)
    }
  }
  onChange = value => {
    let validity = {}
    let inputValidity = document.getElementById(this.props.id || "phoneInput")
      .validity
    for (const key in inputValidity) {
      validity[key] = inputValidity[key]
    }
    if (value) {
      validity.phone = !isEmpty(parseNumber(value, this.state.country))
      if (!validity.phone) {
        validity.valid = false
      } else {
        validity.valid = true
      }
    } else {
      validity.phone = false
      validity.valid = false
    }
    this.setState(
      update(this.state, {
        validity: {
          $set: validity,
        },
      })
    )
    if (this.props.hasOwnProperty("setValidity")) {
      this.props.setValidity(validity)
    }
    this.props.onChange(value)
  }
  render() {
    const { classes, name, id } = this.props
    return (
      <FormControl fullWidth>
        <InputLabel
          htmlFor="phone"
          focused={this.state.phoneInputFocused}
          shrink={this.state.phoneInputFocused || !isEmpty(this.props.value)}
          placeholder=""
          className={classes.phoneLabel}
        >
          {this.props.label || "Phone"}
        </InputLabel>
        <PhoneInput
          name={name || "phone"}
          value={this.props.value}
          onChange={this.onChange}
          onCountryChange={this.handleCountryChange}
          country={this.state.country}
          required
          id={id || "phoneInput"}
          countries={countries}
          flagComponent={FlagComponent}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          displayInitialValueAsLocalNumber
          type={this.props.type || "phone"}
        />
        <FormHelperText className={classes.phoneErrorText} error id="phone">
          {!this.state.validity.valid &&
            this.state.touched && (
              <Fragment>
                <span>Enter valid phone</span>{" "}
                <InfoCircle infoCircleClass={classes.infoCircle}>
                  Enter phone without country code, ie. +1
                </InfoCircle>
              </Fragment>
            )}
        </FormHelperText>
      </FormControl>
    )
  }
}

export default withStyles(styles, { withTheme: true })(PhoneInputComponent)
